<template>

  <div class="detail_d1">
    <div class="font_content">
      <img src="../assets/img/company/contact/log_title.png" width="405" height="47" class="title_img"/>
      <span class="i-first-child">服务电话：0512-68757879 <br>销售总监：(+86)185 0150 5060 <br>邮箱：marketing@cancrieas.com <br>地址：苏州市工业园区汀兰巷192号A1幢7楼 <br>邮编：215127</span>
    </div>
    <img src="../assets/img/company/contact/p1.png" width="623" height="352" class="title_img"/>
  </div>

</template>

<script>

export default {
  data() {
    return {};
  },
  mounted() {

  },
  methods: {}
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

.detail_d1 {
  display: flex;
  flex-direction: row;
  width: 1160px;
  margin-top: 40px;
  margin-bottom: 50px;

  .font_content {
    display: flex;
    flex-direction: column;

    .i-first-child {
      font-size: 18px;
      color: #000;
      font-style: normal;
      font-weight: normal;
      width: 447px;
      margin-right: 90px;
      font-family: Source Han Sans CN;
      line-height: 250%;
      font-style: normal;
      margin-top: 50px;
    }
  }
}
</style>
